import React, { useState } from 'react';
import axios from 'axios';
import { FormControl, Alert, Stack, Box, Typography, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useUserStore from '../store/UserStore.js';
import { login } from '../services/login.js';
import { useTranslation } from 'react-i18next';
import Logo from '../assets/Logo_Color_Training.png';
import { CustomTextField } from '../components/Inputs.jsx';
import { STPButton } from '../components/Botones.jsx';
import { saveUserAction } from '../services/saveUserAction.js';

axios.defaults.withCredentials = true;

export function Login({ setIsAuthenticated }) {
  const { t } = useTranslation();
  const [loginError, setLoginError] = useState("");
  const setUser = useUserStore(state => state.setUser);
  const [loading, setLoading] = useState(false);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    setLoading(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(email)){
      setLoginError(t('login.invalidEmail'));
      setLoading(false);
      return;
    }
    const response = await login(email, password);
    
    if (response) {
      if (response === 'NoPortalAccess') {
        saveUserAction({ email, id_accion: 1, detalles_accion: `No portal access email ${email}` });
        setLoginError(t('login.noPortalAccess'));
        setLoading(false);
      }
      else if (response === "Inicio de sesión exitoso") {
        setUser({ email: email, password: password });
        setIsAuthenticated(true);
        saveUserAction({ email, id_accion: 1, detalles_accion: 'Successful login' });
        navigate('/users');
      }
      else {
        saveUserAction({ email, id_accion: 1, detalles_accion: `Failed login with email ${email}` });
        setLoginError(t('login.error'));
        setLoading(false);
      }
    }
    else {
      saveUserAction({ email, id_accion: 1, detalles_accion: `Failed login with email ${email}` });
      setLoginError(t('login.error'));
      setLoading(false);
    }
  };

  const greenInputProps = {
    '& .MuiFilledInput-root': {
      '&:hover': {
        backgroundColor: 'rgba(0, 128, 0, 0.04)',
      },
      '&.Mui-focused': {
        backgroundColor: 'rgba(0, 128, 0, 0.09)',
      },
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: '#50A579',
    },
    '& .MuiFilledInput-underline:after': {
      borderBottomColor: '#50A579',
    },
  };

  const handleEmailChange = (email) => {
    setLoginError("")
    setEmail(email)
  }

  return (
    loading ? 
    (<Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <CircularProgress sx={{ 
        color: 'rgba(80, 165, 121, 0.7)',
       }}/>
    </Box>) :

    <Stack spacing={2} direction="column" sx={{ m: 1, width: '90%', alignItems: 'center', maxWidth: '700px', height: '100%' }}>
      <img src={Logo} alt="VilaTraining Logo" style={{ height: '100px' }} onClick={() => navigate('/')} />
    
      <Box sx={{ height: '10px' }} />

      <FormControl sx={{ ...greenInputProps, width: '90%' }} variant="filled">
        <CustomTextField
          label={t('login.email')}
          id="filled-start-adornment-mail"
          variant="filled"
          value={email}
          onChange={(e) => handleEmailChange(e.target.value)}
          sx={{ ...greenInputProps, width: '90%' }}
        />
        <CustomTextField
          label={t('login.password')}
          variant="outlined"
          type="password"
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ ...greenInputProps, width: '90%' }}
        />
      </FormControl>
      {loginError && <Alert severity="error">{loginError}</Alert>}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '90%' }}>
        <Typography variant="body2" onClick={() => navigate('/password-recovery')} sx={{ cursor: 'pointer', color: '#50A579' }}>
          {t('login.recoverPass')}
        </Typography>
      </Box>

      <STPButton variant="contained" sx={{ width: '70%' }} onClick={handleLogin}>{t('login.access')}</STPButton>

      <Typography variant="body2" sx={{ textAlign: 'center', pt: 4 }}>
        {t('login.noAccount')}
        <br />
        {t('login.contactUs')}
        <br />
        <b>{t('login.contact')}</b>
      </Typography>

      <Typography variant="overline" >
        VERSION 2.0
      </Typography>
      
    </Stack>
  );
}
